module.exports = __webpack_public_path__ + "assets/img/service-293e6184.png";